document.addEventListener('DOMContentLoaded', () => {
    const extrasToggle = document.getElementById('extras-toggle') as HTMLElement;

    if (extrasToggle) {
        extrasToggle.addEventListener('click', () => {
            const parent = extrasToggle.parentElement as HTMLElement;
            parent.classList.toggle('extras-open');
        });
    }
});